import { render, staticRenderFns } from "./GalleryThumbPerson.vue?vue&type=template&id=225d2c9d&scoped=true&"
import script from "./GalleryThumbPerson.vue?vue&type=script&lang=js&"
export * from "./GalleryThumbPerson.vue?vue&type=script&lang=js&"
import style0 from "./GalleryThumbPerson.vue?vue&type=style&index=0&id=225d2c9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225d2c9d",
  null
  
)

export default component.exports